import { Icon } from '@orthly/ui-primitives';
import React from 'react';

export const BooleanIcon: React.FC<{ val: boolean }> = ({ val }) =>
    !val ? (
        <Icon icon={'CloseIcon'} color={'error'} />
    ) : (
        <Icon icon={'CheckIcon'} color={'inherit'} style={{ color: '#08C28B' }} />
    );
